
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import * as _ref_anMtbWQ1_ from 'js-md5';
import { instantiate } from './pewmApp_1.4.uninstantiated.mjs';


const exports = (await instantiate({
    './skiko.mjs': Li9za2lrby5tanM,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_,
    'js-md5': _ref_anMtbWQ1_
})).exports;

export const {
memory,
_initialize
} = exports


